module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn_mail-5dd877b64a201fecab89dd391bae10b7.svg";